import { List, Record } from 'immutable';
import { visibilityOptions } from '../../constants/ArticleVisibilityConstants';
import TableConstants from '../../constants/manage/TableConstants';
const ManageFilters = Record({
  allFilteredArticlesSelected: false,
  filteredArticlesCount: 0,
  authorId: undefined,
  categoryIds: undefined,
  limit: TableConstants.NUM_ROWS_PER_PAGE,
  offset: TableConstants.DEFAULT_INIT_OFFSET,
  searchTerm: TableConstants.DEFAULT_SEARCH,
  selectedArticles: List(),
  sortColumn: TableConstants.UPDATED_AT_PROPERTY,
  sortDir: TableConstants.DESC_ORDER,
  visibility: visibilityOptions.ALL_AUDIENCE
});
export default ManageFilters;